import React from "react"
import { Box, Stack, Typography } from "@mui/material"
import { FolderOpen } from "@phosphor-icons/react"
import { GenericCircleIcon } from "./GenericCircleIcon"

export const GenericNoData = (props) => {
  const {
    icon,
    label = 'No data found',
    height = '20vh',
    size = '90px',
    labelVariant = 'subtitle1',
    labelColor = 'grey.dark',
    customLabel
  } = props;

  return (
    <Box sx={{ height: height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Stack gap={1} alignItems={'center'}>
        <GenericCircleIcon size={size} color={'primary.main'}>
          {icon ?? <FolderOpen size={40} />}
        </GenericCircleIcon>
        {customLabel ?? <Typography variant={labelVariant} fontWeight={700} color={labelColor}>{label}</Typography>}
      </Stack>
    </Box>
  )
}